import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import { CookiesProvider } from 'react-cookie';
import LangProvider from '../components/LangProvider';
import Login from './index';

export default (selector, options) => {
  const render = (Component) => {
    ReactDOM.render(
      <AppContainer>
        <CookiesProvider>
          <LangProvider>
            <Component initProps={options} />
          </LangProvider>
        </CookiesProvider>
      </AppContainer>,
      document.querySelector(selector),
    );
  };

  render(Login);

  if (process.env.NODE_ENV === 'development' && module.hot) {
    module.hot.accept('./index', () => {
      // eslint-disable-next-line global-require
      const NextComponent = require('./index').default;
      render(NextComponent);
    });
  }
};



// WEBPACK FOOTER //
// ./app/Assets/js/features/login/renderInto.js